import { render, staticRenderFns } from "./identificacion-sustancias.vue?vue&type=template&id=43c722b2&scoped=true&"
import script from "./identificacion-sustancias.vue?vue&type=script&lang=js&"
export * from "./identificacion-sustancias.vue?vue&type=script&lang=js&"
import style0 from "./identificacion-sustancias.vue?vue&type=style&index=0&id=43c722b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c722b2",
  null
  
)

export default component.exports